import React from 'react';
import './index.scss';

const Quote = ({
  content,
  title,
  updated,
  randomNum,
  className,
  onClick,
  onDelete,
  onEdit,
  isLogged,
}) => {
  return (
    <div className={`${randomNum > 1 ? 'randomCard' : ''} ${className}`} onClick={onClick}>
      <div className="card text-center p-3 quote-blue">
        {isLogged && (
          <div className="card-buttons">
            <span className="fa fa-pen card-btn" onClick={onEdit} />
            <span className="fa fa-trash card-btn" onClick={onDelete} />
          </div>
        )}
        <figure className="mb-0">
          <blockquote className="blockquote">
            <h3>{title}</h3>
            <p>{content}</p>
          </blockquote>
          <figcaption className="blockquote-footer mb-0">{updated}</figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Quote;
